import request from 'api/requestUtils'
import { RequestDemoData } from 'businessTraveller/components/demo-modal/BusinessTravellerRequestDemoModal'
import { VideoChatRequestBody } from 'components/Pages/VideoChatPage'
import config from 'constants/config'

export function sendEnquiryRequest({
  issue,
  subIssue,
  name,
  email,
  phone,
  enquiry,
  orderId,
}, regionCode) {
  const payload: any = {
    issue,
    subissue: subIssue,
    customer_name: name,
    customer_email: email,
    customer_phone: phone,
    customer_country: regionCode,
    enquiry,
  }
  if (orderId) {
    payload.order_id = orderId
  }
  return request.post('/api/notify/enquiry', payload)
}

export function sendTravelBookingFormRequest({
  travellers,
  orderId,
}) {
  return request.post(`/api/orders/${orderId}/booking-details`, {
    travellers,
    id_order: orderId,
  }, { credentials: 'include' })
}

export function sendShareWithFriendRequest({ friendEmail, friendMessage, type, offerId, memberId, utm, heroImageId, location, region }) {
  return request.post('/api/le-notify/share-with-friend', {
    friend_email: friendEmail,
    friend_message: friendMessage,
    customer_id: memberId,
    type,
    offer_id: offerId,
    hero_image: heroImageId,
    location,
    region,
    utm,
  }, { credentials: 'include' })
}

export function sendShareReferralLinkRequest({ friend_email, referral_customer_id, region, utm }) {
  return request.post<App.ApiResponse<any>, unknown>('/api/le-notify/share-referral-link', {
    friend_email,
    referral_customer_id,
    region,
    utm,
  }, { credentials: 'include' })
}

export function sendQuote(body) {
  return request.post('/api/le-notify/quote-automation', body, { credentials: 'include' })
}

export function sendSkyCheckConfirmation(body) {
  return request.post('/api/le-notify/skycheck-request-email', body, { credentials: 'include' })
}

export function sendSkyCheckConfirmationToCS(body) {
  return request.post('/api/le-notify/skycheck-confirmation', body, { credentials: 'include' })
}

export function sendTripQuote(body) {
  return request.post('/api/le-notify/trip-quote-automation', body, { credentials: 'include' })
}

export function sendAccountDeleteRequestEmail(customer_id: string) {
  return request.post<{ message: string}, any>('/api/le-notify/account-delete-request', {
    customer_id,
    brand: config.BRAND,
  }, { credentials: 'include' })
}

export function sendVideoChatRequest(body: VideoChatRequestBody) {
  return request.post(
    '/api/le-notify/sales-video-chat-notification',
    body,
    { credentials: 'include' },
  )
}

export function sendBusinessDemoRequest(body: RequestDemoData) {
  return request.post(
    '/api/le-notify/business-request-demo',
    body,
    { credentials: 'include' },
  )
}
